var render = function render(){var _vm=this,_c=_vm._self._c;return _c('e-form-group',{attrs:{"name":_vm.fieldName,"inputType":"select","label":"Срок эксплуатации","model":_vm.fields,"options":_vm.options,"tabView":_vm.tabView,"formGroupStyle":_vm.formGroupStyle,"required":_vm.required}})
}
var staticRenderFns = []

export { render, staticRenderFns }